import {CareServicesView} from '../../../../../../../components/care-services/care-services-view';

export function SeniorCareServicesProfessionalCaregiverScreen() {
  return <CareServicesView mode="senior" />;
}
